/* global dataLayer:false */

(function() {
	var downloadLinks = document.querySelectorAll('.js-freebie-download-link');
	for (var i = 0 ; i < downloadLinks.length; i++) {
		var downloadLink = downloadLinks[i];

		downloadLink.addEventListener('click', function() {
			// GA tracking using Google Tag Manager
			dataLayer.push({
				'event': 'gaEvent',
				'eventCategory': 'Resources',
				'eventAction': 'downloaded',
				'eventLabel': this.getAttribute('data-ga-label'),
			});
		});
	}
})();
